import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { compact, get } from 'lodash';
import { selection } from '../../utils/filter';
import { setCategories } from '../../utils/storage';

const humans = ['jockey', 'trainer', 'owner'];

class FilteringComponent extends PureComponent {
    constructor(props) {
        super(props);

        // key for getting data from API request
        this.dataKey = '';

        // default value that would be passed if response
        // will come with empty data[dataKey]
        this.emptyData = [];
    }

    // handle received from server data
    onDataReceive = (data) => {
        this.setState({
            data: get(data, `data.${this.dataKey}`, this.emptyData),
            loading: false,
        });
    }

    // handle received from server error
    onDataError = (error) => {
        console.warn(error);
        this.setState({ data: this.emptyData, loading: false, fetchError: true });
    }

    // when button "Apply" are clicked we need to save new categories
    onFilterApply = (categories) => {
        this.setState({ categories, loading: true, fetchError: false });

        const selectedValues = selection.getValues(categories);
        const requestUri = this.buildUrl(selectedValues);

        const { params } = this.props;

        if (params && params.tab && params.type && humans.includes(params.type)) {
            setCategories(params.tab, params.type, categories);
        }

        axios.get(requestUri)
            .then(({ data }) => this.onDataReceive(data))
            .catch(this.onDataError);
    }

    // default way to building uri string
    buildUrl = ({ timePeriod, raceType, raceCategory }) => {
        const { type, id, tab } = this.props.params;
        const uriValues = [timePeriod, raceType, raceCategory];
        return `${type}/filter/${tab || this.tab}/${id}/${compact(uriValues).join('/')}`;
    }

    // default way to build filter status
    renderStatus() {
        const labels = selection.getCaptions(this.state.categories);
        const statusText = Object.values(labels).join(', ');
        return <h2 className="ui-filter__statusText">{statusText}</h2>;
    }
}

FilteringComponent.propTypes = {
    params: PropTypes.shape({
        type: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
        tab: PropTypes.string,
    }).isRequired,
};

export default FilteringComponent;



// WEBPACK FOOTER //
// ./src/js/shared/filter/FilteringComponent.jsx